import { useSubscribeToPublicWebsocketEvent } from '~/core/shared/contexts/websockets';
import { AnyDocument } from '../../../../types';
import { buildDocumentChannelName } from '../../logic/buildDocumentChannelName';
import { DocumentPrivateWebsocketEvent } from '../../types/DocumentPrivateWebsocketEvent';
import { DocumentPrivateWebsocketEventPayload } from '../../types/DocumentPrivateWebsocketEventPayload';

export const useSubscribeToFraudAnalysisUpdated = (
  documentId: AnyDocument['id'],
  onUpdate: (
    payload: DocumentPrivateWebsocketEventPayload[DocumentPrivateWebsocketEvent.FraudAnalysisUpdated],
  ) => void,
): void => {
  useSubscribeToPublicWebsocketEvent(
    buildDocumentChannelName(documentId),
    DocumentPrivateWebsocketEvent.FraudAnalysisUpdated,
    onUpdate,
  );
};
